module.exports = __webpack_public_path__ + "static/img/kjdy04.3e8d26d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy04.png
// module id = 24
// module chunks = 0